export const COMMON_SET_IS_DRAGGING = 'COMMON_SET_IS_DRAGGING';



// WEBPACK FOOTER //
// ./src/state/dragAndDrop/types.js